export const dateFormats = {
  start_date: "MM-DD-YYYY",
  start_date_api: "YYYY-MM-DD",
  end_date: "MM-DD-YYYY",
  end_date_api: "YYYY-MM-DD",
};

export const ChartConstants =
{
  disabilities: { key: 'disabilities', title: 'Disibility', graph_key: '1' },
  gender: { key: 'gender', title: 'Gender', graph_key: '2' },
  education_level: { key: 'education_level', title: 'Education', graph_key: '3' },
  experience_level: { key: 'experience_level', title: 'Experience Level', graph_key: '4' },
  household: { key: 'household', title: 'Household Income', graph_key: '5' },
  age_group: { key: 'age_group', title: 'Age', graph_key: '6' },
  military_status: { key: 'military_status', title: 'Military Service', graph_key: '7' },
  ethnicities: { key: 'ethnicities', title: 'Ethnicity', graph_key: '8' },
  zip_code_users: { key: 'zip_code', title: 'Location', graph_key: '9' },
  careers: { key: 'careers', title: 'Careers', graph_key: '10' },
  skill_categories: { key: 'skill_categories', title: 'Skill Categories', graph_key: '11' },
  career_categories: { key: 'career_categories', title: 'Career Categories', graph_key: '12' },
  certifications: { key: 'certifications', title: 'Certifications', graph_key: '13' },

}


